/* eslint-disable @typescript-eslint/no-explicit-any */
import BreadCrumb from "../components/BreadCrumb"
import FilterGroup from "./components/FilterGroup"
import { ExploreItem, ExploreItemType } from "./components/ExploreItem"
import { useExploreData } from "../useExploreData"
import LoadingIndicator from "../../components/LoadingIndicator"

export enum ExploreEntityType {
  API = 'api',
  QUERY = 'query',
  DASHBOARD = 'dashboard',
  DATA_SOURCE = 'data-source',
  CONTRACT = 'contract',
  PROJECT = 'project',

}




const ExploreApis = () => {
  const {
    publicApis,
    isLoading
  } = useExploreData()


  if (isLoading) return <LoadingIndicator />

  return <div className="">
    <div className="border-b-2 px-6 py-2 flex justify-between items-center">
      <BreadCrumb  >
        Explore
        <span className="mx-3">/</span>
        Browse APIs ({publicApis.length})
      </BreadCrumb>
      <FilterGroup />
    </div>
    <div className="px-16 py-8">
      {/* List of Items */}
      <div id="section-content" className=" flex justify-between flex-wrap">
        {
          publicApis.map((item, index) => {
            return <ExploreItem type={ExploreItemType.API} key={index}
              title={item?.name}
              author={item?.owner?.name}
              imgUrl={item?.image}
              description={item?.detail}
              item={item} />
          })
        }
      </div>
    </div>
  </div>
}

export default ExploreApis;